import { render, staticRenderFns } from "./ChangeProject.vue?vue&type=template&id=056f1658&"
import script from "./ChangeProject.vue?vue&type=script&lang=js&"
export * from "./ChangeProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports